import api from "./http-common";
import Cookies from "js-cookie";

// const token = JSON.parse(localStorage.getItem("token"));
const token = Cookies.get("jwtToken");


const getEmployees = (data) => {
  return api.post("api/Route/EmployeeStatus", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getdutytripinfo = (data) => {
  return api.post("api/User/Getdutytripinfo", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

// const allocateDuty = (data) => {
//   return http.post("api/Route/TodaysDutyAllotment", data, {
//    headers: { Authorization: "Bearer " + token },
//  });
// }

const updateDuty = (data) => {
  return api.post("api/Route/UpdateTodaysDutyAllotment", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getBusInfo = (data) => {
  return api.post("api/Route/GetBusInfo", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getCanceledDuty = () => {
  return api.get("api/Route/GetCanceledDuty", {
    headers: { Authorization: "Bearer " + token },
  });
};

const getAllocatedDuty = () => {
  return api.get("api/Route/GetAllocatedDuty", {
    headers: { Authorization: "Bearer " + token },
  });
};

const getBusAllotDuty = () => {
  return api.get("api/Route/GetBusAllotDuty", {
    headers: { Authorization: "Bearer " + token },
  });
};

const checkCrewMannualy = (data) => {
  return api.post("api/Route/GetEmpSts", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const checkCrewMannualyNew = (data) => {
  return api.post("api/Route/CheckCrewLocSts", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const savePhotoWithUser = (data) => {
  return api.post("api/Route/savePhotoWithUser", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const assignDblDutyAllocation = (data) => {
  return api.post("api/Route/DblDutyAllocation", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const addExtraDuty = (data) => {
  return api.post("api/Route/AddExtraDuty", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const fetchExtraDutys = () => {
  return api.get("api/Route/getExtraDutys", {
    headers: { Authorization: "Bearer " + token },
  });
};



const DutyPostingService = {
  getEmployees,
  getdutytripinfo,
  // allocateDuty,
  updateDuty,
  getBusInfo,
  getCanceledDuty,
  getAllocatedDuty,
  getBusAllotDuty,
  checkCrewMannualy,
  checkCrewMannualyNew,
  savePhotoWithUser,
  assignDblDutyAllocation,
  addExtraDuty,
  fetchExtraDutys,
};

export default DutyPostingService;
